import { useRef } from "react";

// A ref that always holds the value of the last render: for callbacks invoked
// later (e.g. debounced) that must act on the current values, not on the ones
// of the render that created them.
export default function useLatestRef(value) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
